module.exports = __webpack_public_path__ + "img/umbrel-qr-icon.a521c058.svg";